// extracted by mini-css-extract-plugin
export default {"header":"Perfil_header__ZrJhc","panel":"Perfil_panel__EbTqW","panelSection":"Perfil_panelSection__y1V0-","subHeader":"Perfil_subHeader__K7P-L","userImg":"Perfil_userImg__6087u"};